export default __webpack_public_path__ + "static/media/LeagueSpartan-ExtraBold.59dea6c3.woff";